import { css } from '@emotion/css';

export const styleSpin = css`
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  .anticon-loading {
    left: calc(
      50% - 20px
    ); // loading比较特殊, 可能因为有动画的成分在, 用transform的话样式会变的非常诡异...所以暂时用这种方式来减去loading本身
    top: calc(50% - 20px);
    position: absolute;
    font-size: 40px !important;
    svg {
      font-size: 40px;
    }
  }
`;
